/**
 * src/game/progression/active-campaign-stage.ts —
 * 「目前正在打哪一個闖關關卡」的 module-level flag.
 *
 * 為什麼用 module flag(對齊 horizontal-battle-scene.ts 既有
 * `_pendingTutorialBossSpawn` / `_pendingTileMapKey` pattern):
 *   - CampaignMapScene 點關卡 → set flag → scene.start('HorizontalBattleScene')。
 *   - 戰鬥勝利 → ResultScene 讀 flag → markStageCleared(該關)→ 評星 → 回地圖。
 *   - 戰鬥場景的 init(data) 同時也吃 { bossId, hubFactionId, stage } 帶背景/boss/難度;
 *     這個 flag 只額外攜帶「闖關 stageId」(init data 用不到的語意),讓 result
 *     能對映回正確的闖關關卡,不必改 init 的型別契約。
 *   - consumed-on-read:結算完即清,避免「下次非闖關戰鬥」誤標某關通關。
 *
 * 非闖關入口(TitleScene / debug / 既有隨機戰鬥)永遠不 set 此 flag → 維持
 * 原行為,result-scene 不做任何闖關標記(向後相容)。
 */

/** 目前進行中的闖關關卡 id;null = 非闖關戰鬥(隨機/教學/塔等)。 */
let _activeCampaignStageId: string | null = null;

/**
 * 設定「接下來這場戰鬥屬於哪一個闖關關卡」。由 CampaignMapScene 在 start
 * 戰鬥前呼叫。傳 null 可清除。
 */
export function setActiveCampaignStage(stageId: string | null): void {
  _activeCampaignStageId = (typeof stageId === 'string' && stageId.length > 0) ? stageId : null;
}

/** 純讀目前 flag(不清除)。供 UI / 測試查詢。 */
export function peekActiveCampaignStage(): string | null {
  return _activeCampaignStageId;
}

/**
 * 讀-並-清 flag。ResultScene 在勝利結算時呼叫:取得本場對應的闖關關卡 id
 * 後立刻清空,確保只標記一次、不漏到下一場非闖關戰鬥。
 */
export function consumeActiveCampaignStage(): string | null {
  const v = _activeCampaignStageId;
  _activeCampaignStageId = null;
  return v;
}
